import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import RubricSetup from "./routes/RubricSetup";
import ChecklistSetup from "./routes/ChecklistSetup";
import SinglePointRubricSetup from "./routes/SinglePointRubricSetup";
import ScoreBasedRubricSetup from "./routes/ScoreBasedRubricSetup";
import StandardBasedRubricSetup from "./routes/StandardBasedRubricSetup";

export default store => ({
  path: "assessmentTool",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    RubricSetup(store),
    ChecklistSetup(store),
    SinglePointRubricSetup(store),
    ScoreBasedRubricSetup(store),
    StandardBasedRubricSetup(store),
  ],
});
